// extracted by mini-css-extract-plugin
export default {"buttonContainer":"_7H0fX","alignToEdge":"eeRpH","buttonIcon":"ysOim","buttonCaption":"_92sf6","buttonSpacer":"qyP6O"};